<template>
    <b-input-group class="tableSearchGroup">
        <b-form-input ref="input" class="tableSearch" placeholder="Search" v-model="searchTerm"></b-form-input>
        <b-input-group-append>
            <span v-show="searchTerm.length" @click="clearSearch" class="input-group-text border-left-0 pointer"><i class="fal fa-times blue"></i></span>
            <span class="input-group-text border-left-0"><i class="fal fa-search blue"></i></span>
        </b-input-group-append>
    </b-input-group>
</template>

<script>

export default {
    props: ['tableRef'],
    data() {
        return {
            searchTerm : '',
            delayTimer : {}
        }
    },
    watch:{
        searchTerm: function(val){
            
            clearTimeout(this.delayTimer);

            this.delayTimer = setTimeout(() => {
                // Rollbar #37: tableRef may not be registered in the store yet
                // (e.g. parent registers it after this watcher first fires).
                // Skip the commit in that case but still emit/refresh so the UI
                // keeps working.
                const tableEntry = this.$store.getters.getTables[this.tableRef];
                if (tableEntry && tableEntry.search != val) {
                    this.$store.commit('setTableSearchTerm', {ref: this.tableRef , val: val});
                }
                this.$emit('vt-search-updated', {
                    table: this.tableRef,
                    search: val
                })
                this.$events.fire('vt-refresh-' + this.tableRef, {})
               
            } , 300)

        }
    },
    methods: {
        clearSearch() {
            this.searchTerm = '';
        }
    },
    mounted() {
        if (typeof this.$store.getters.getTables[this.tableRef] !== 'undefined' ) //undefined on the first load
            if (this.$parent.vTablesConfigs[this.tableRef].useStore) 
                this.searchTerm = this.$store.getters.getTables[this.tableRef].search;
            else 
                this.$store.getters.getTables[this.tableRef].search = ''
    }

}
</script>
